import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'


const rootStyle = {
  border: 'solid 1px',
  bgcolor: 'grey.500',
  width: 'fit-content',
  position: 'absolute',
  top: theme => theme.spacing(2),
  left: theme => theme.spacing(2),
}

const itemStyle = {
  display: 'inline-block',
  textAlign: 'center',
  padding: '2px 5px',
  '&:not(:first-child)': {
    borderLeft: 'solid 1px',
    borderColor: 'grey.500',
  },
}

const Legend = ({ generalImpression, sx }) => generalImpression
  ? <Box sx={{ rootStyle, ...sx }}>
    <Box sx={{ ...itemStyle, color: 'error.main' }}>
      <span>I&nbsp;</span>
      <span>Insufisant</span>
    </Box>
    <Box sx={{ ...itemStyle, color: 'info.main' }}>
      <span>S&nbsp;</span>
      <span>Satisfaisant</span>
    </Box>
    <Box sx={{ ...itemStyle, color: 'success.main' }}>
      <span>P&nbsp;</span>
      <span>Performant</span>
    </Box>
  </Box>
  : <Box sx={{ rootStyle, ...sx }}>
    <Box sx={{ ...itemStyle, color: 'info.light' }}>
      <span>/&nbsp;</span>
      <span>Vu</span>
    </Box>
    <Box sx={{ ...itemStyle, color: 'info.main' }}>
      <span>X&nbsp;</span>
      <span>Restitué</span>
    </Box>
    <Box sx={{ ...itemStyle, color: 'success.main' }}>
      <span>O&nbsp;</span>
      <span>Assimilé</span>
    </Box>
    <Box sx={{ ...itemStyle, color: 'error.main' }}>
      <span>•&nbsp;</span>
      <span>A revoir</span>
    </Box>
  </Box>

Legend.propTypes = {
  generalImpression: PropTypes.bool,
  sx: PropTypes.object,
}

export default Legend
